import * as React from 'react'

export default (props) =>
  <svg xmlns="http://www.w3.org/2000/svg" width="2.015" height="11.722" viewBox="0 0 2.015 11.722" {...props} transform="">
    <path id="Path_32691" data-name="Path 32691" d="M10,6v5.924" transform="translate(-8.998 -5)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path id="Path_32692" data-name="Path 32692" d="M10,14h.015" transform="translate(-9 -3.278)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
